













































import {
  computed,
  defineComponent,
  Ref,
  ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import CMakeLogo from '~/components/shared/configurable/make/CMakeLogo.vue'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'

export default defineComponent({
  components: { CExpandableContent, CMakeLogo, CFormError },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name, options, fieldValues } = toRefs(props)
    const selectedOptions = ref<string[]>(fieldValues.value || [])
    const { value, error, changeValue } = useDynamicForm(props, {
      onValue: (v: Ref<string[]>) => {
        if (v.value?.length) {
          selectedOptions.value = v.value
        }
      }
    })

    const selectedServicingCategory = computed(
      () => fieldValues.value.servicing_category
    )

    watch(selectedServicingCategory, (val, oldVal) => {
      if (val !== oldVal) {
        deselectAll()
      }
    })

    function handleCheckboxesInput(val: any) {
      changeValue(name.value, val)
    }

    function selectAll() {
      changeValue(
        name.value,
        options.value.map(o => o.value)
      )
    }

    function deselectAll() {
      selectedOptions.value = []
      changeValue(name.value, [])
    }

    return {
      value,
      error,
      handleCheckboxesInput,
      selectedOptions,
      selectAll,
      deselectAll
    }
  }
})
